<template>
  <div id="wrapper">
    <div id="content-wrapper" class="page">
      <div class="container-fluid">
        <a href="#" @click.prevent="goBack">
          <i class="fas fa-arrow-left"></i> Back
        </a>
        <b-card
          class="mt-4 mr-auto ml-auto"
          style="width:600px; min-width:600px;"
        >
          <form @submit.prevent="updateItem" class="">
            <div class="col-lg-12">
              <div class="form-group row">
                <div class="col-sm-5 col-form-label" style="max-width:34%;">
                  <b>Email</b>
                </div>
                <div class="col-sm-8" style="max-width:66%;">
                  <input
                    type="text"
                    class="form-control"
                    name="email"
                    v-model="email"
                    autocomplete="off"
                    required
                    readonly
                  />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-5 col-form-label" style="max-width:34%;">
                  <b>Full name</b>
                </div>
                <div class="col-sm-8" style="max-width:66%;">
                  <input
                    type="text"
                    class="form-control"
                    name="hovaten"
                    v-model="hovaten"
                    autocomplete="off"
                    required
                    readonly
                  />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-5 col-form-label" style="max-width:34%;">
                  <b>Old password</b>
                  <code> *</code>
                </div>
                <div class="col-sm-8" style="max-width:66%;">
                  <input
                    type="password"
                    class="form-control"
                    name="password"
                    v-model="old_password"
                    required
                  />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-5 col-form-label" style="max-width:34%;">
                  <b>New password</b>
                  <code> *</code>
                </div>
                <div class="col-sm-8" style="max-width:66%;">
                  <input
                    type="password"
                    class="form-control"
                    name="password"
                    v-model="new_password"
                    required
                  />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-5 col-form-label" style="max-width:34%;">
                  <b>Comfirm password</b>
                  <code> *</code>
                </div>
                <div class="col-sm-8" style="max-width:66%;">
                  <input
                    type="password"
                    class="form-control"
                    name="password"
                    v-model="re_password"
                    required
                  />
                </div>
              </div>
              <div class="mt-4 float-right" style="max-width: 20%;">
                <b-button variant="info" type="submit"
                  ><i class="fas fa-save mr-2"></i>Submit</b-button
                >
              </div>
            </div>
          </form>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "User",
  components: {},
  data() {
    return {
      item: null,
      email: null,
      hovaten: null,
      old_password: null,
      new_password: null,
      re_password: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    axios
      .all([axios.get(`/api/employeesystem/byid/${to.params.id}`)])
      .then(
        axios.spread((user) => {
          next((vm) => vm.initData(user.data, null));
        })
      )
      .catch((err) => {
        next((vm) => vm.initData(null, err));
      });
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    initData(item, err) {
      if (item) {
        this.item = item;
        this.email = this.item.email;
        this.hovaten = this.item.hovaten;
      } else if (err) {
        this.$toast.error(err.response.data, "Error", { timeout: 10000 });
      } else {
        this.$toast.error("Not found!!!", "Error", { timeout: 10000 });
      }
    },
    updateItem() {
      if (this.new_password != this.re_password) {
        this.$toast.error("Mật khẩu không khớp nhau", "Lỗi", { timeout: 3000 });
        return;
      }

      axios
        .put("/api/employeesystem/changepassword", {
          id: this.item.id,
          new_password: this.new_password,
          old_password: this.old_password,
        })
        .then((res) => {
          this.$toast.success("Đổi mật khẩu thành công !", "Thành công", {
            timeout: 2000,
          });
          // this.old_password = null;
          // this.new_password = null;
          // this.re_password = null;
          this.goBack();
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
          this.old_password = null;
          this.new_password = null;
          this.re_password = null;
        });
    },
  },
};
</script>
